import W4D_PageLoader from "../utilities/w4d-page-loader.js";

(function () {
    class W4D_GTranslate {
        constructor() {
            this.popover = document.getElementById('language-tax-selector');

            if (!this.popover) {
                return;
            }

            this.defaultLanguage = this.popover.dataset.gtranslateDefaultLanguage;
            this.init();
        }

        init() {
            const langInputs = this.popover.querySelectorAll('input[name="site-language"]');
            langInputs.forEach((input) => {
                input.addEventListener('change', (event) => this.changeLanguage(event));
            });

            this.initScrollIndicators();

            window.addEventListener('resize', () => {
                if (this.popover.matches && this.popover.matches(':popover-open')) {
                    this.updateScrollState();
                }
            });

            this.popover.addEventListener('toggle', (event) => {
                if (event.newState === 'open') {
                    requestAnimationFrame(() => this.updateScrollState());
                }
            });
        }

        initScrollIndicators() {
            const fieldsets = this.popover.querySelectorAll('fieldset');
            fieldsets.forEach((fieldset) => {
                const topSentinel = fieldset.querySelector('.ltp-sentinel--top');
                const bottomSentinel = fieldset.querySelector('.ltp-sentinel--bottom');

                if (!topSentinel || !bottomSentinel) {
                    return;
                }

                const observer = new IntersectionObserver((entries) => {
                    entries.forEach((entry) => {
                        if (entry.target === topSentinel) {
                            fieldset.classList.toggle('can-scroll-up', !entry.isIntersecting);
                        } else if (entry.target === bottomSentinel) {
                            fieldset.classList.toggle('can-scroll-down', !entry.isIntersecting);
                        }
                    });
                }, { root: fieldset });

                observer.observe(topSentinel);
                observer.observe(bottomSentinel);
            });
        }

        changeLanguage(event) {
            const language = event.currentTarget.value;

            if (!this.defaultLanguage) {
                console.error('ERROR: GTranslate default language dataset value is missing.');
                return;
            }

            if (typeof window.doGTranslate !== 'function') {
                console.error('ERROR: window.doGTranslate is not defined or initialized yet.');
                return;
            }

            W4D_PageLoader.show();
            if (typeof this.popover.hidePopover === 'function') {
                this.popover.hidePopover();
            } else {
                console.warn('Popover API (hidePopover) is not supported on this browser or element.');
            }

            const gtranslateCode = `${this.defaultLanguage}|${language}`;
            window.doGTranslate(gtranslateCode);
        }

        updateScrollState() {
            this.popover.querySelectorAll('fieldset').forEach((fieldset) => {
                const selectedInput = fieldset.querySelector('input:checked');
                if (selectedInput) {
                    const selectedItem = selectedInput.closest('label') || selectedInput;
                    selectedItem.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
                }
            });
        }
    }

    document.addEventListener('DOMContentLoaded', () => new W4D_GTranslate());
})();
